
<template>
  <modal name="ModalChangeOrder" class="event-modal modal-change-order-detail" :width="1300" :height="670" :scrollable="true" @before-open="beforeOpen" @before-close="beforeClose">
    <div class="modal-header">
      <span class="modal-header-change-order-text">{{ modalData.title }}</span>
    </div>
    <div class="modal-body-changeOrderDetail">
      <div class="modal-header-line"></div>
      <a>
        <br/>
        <span class="modal-body-changeOrderDetail-text">Requesting changes will charge you based on contract rates. Cancelling will not.</span>
      </a><br/>
      <DataTable class="modal-body-changeOrderDetail-event-detail" :editable="true" :showOnModal="true"
                 :parentEvent="[actionData]"></DataTable>
    </div>
  </modal>
</template>
<script>
import consts from '../../_consts';
import DataTable from '../datatable/DataTable';

export default {
  name: '',
  components: {
    DataTable
  },
  data () {
    return {
      actionTypes: consts.modalAction,
      modalData: {},
      actionData: {}
    }
  },
  methods: {
    hideModal () {
      this.$modal.hide('ModalChangeOrder');
    },
    beforeOpen (event) {
      this.modalData = consts.mappingModalActionToModalData[event.params.action];
      this.actionData = event.params.data;
    },
    beforeClose () {
      // this.$modal.show('eventModal', modalData);
    }
  },
  computed: {
  }
}
</script>



// WEBPACK FOOTER //
// ModalChangeOrderDetail.vue?53448da4